import FormField from 'Components/FormComponents/FormField';
import Button from 'Components/FormComponents/Button';
import {ReactComponent as CloseIcon} from 'assets/icons/close.svg';
import {useCallback, useMemo} from 'react';
import {useIntl} from 'react-intl';
import formCallbacks from 'utils/formCallbacks';
import {createSelectOptions} from 'utils/algoliaFiltration';

const SidebarFilters = (
  {
    formState,
    setFormState,
    formConfig,
    facets,
    clearCallback,
    filtersVisibility,
    setFiltersVisibility,
    filtersState,
    setFilters,
    sortingFilters,
    sortState,
    setSortState,
    disciplines,
    universities,
    pgmType,
  }) => {
  const intl = useIntl();
  const {disciplines: disc} = JSON.parse(disciplines) || {};
  const {university: univ} = JSON.parse(universities) || {};
  const pgmTypes = JSON.parse(pgmType);

  const disciplineOptions = useMemo(
    () => createSelectOptions(disc, 'field_prgm_disciplines_tid', 'name', 'tid'),
    [disciplines]
  );
  const universityOptions = useMemo(
    () => createSelectOptions(univ, 'field_prgm_university_nid', 'field_short_title', 'nid'),
    [disciplines]
  );

  const fields = useCallback(() => {
    return formConfig.map((field) => {
      const {type, name} = field;
      let result = {}

      if (facets.hasOwnProperty(field.name)) {
        if (type === 'checkboxes' || type === 'select' || type === 'radios') {
          const options = [];
          for (const [key, value] of Object.entries(facets[name])) {
            options.push({
              label: `${key} (${value})`,
              value: key
            });
          }

          if (type === 'select' || type === 'radios') {
            options.unshift({
              label: intl.formatMessage({id: 'Algolia.SidebarFilters.SelectOrRadios.FirstOption'}),
              value: '',
              selected: true
            })
          }

          field.options = options;
          field.isTranslated = false;
        }
        result = field;
      }
      else if (field.options?.length || type === 'toggle') {
        result = {...field, filter: true};
      }
      else if (name === 'field_prgm_disciplines_tid') {
        field.options = disciplineOptions;
      }
      else if (name === 'field_prgm_university_nid') {
        field.options = universityOptions;
      }
      else if (name === 'field_prgm_type') {
        const typeOptions = [];

        // eslint-disable-next-line
        for (const [key, value] of Object.entries(pgmTypes)) {
          typeOptions.push({
            label: value.name,
            value: `field_prgm_type:"${value.name}"`,
          });
        }

        field.options = typeOptions;
      }

      result = formCallbacks(result);

      return result;
    });
  }, [facets, formConfig]);

  if (!facets || !formConfig) {
    return null;
  }

  const renderFields = () => {
    if (!fields().length) {
      return '';
    }

    return fields().map((field) => {
      if (field.filter) {
        return (
          <FormField fieldConfig={field} state={filtersState}
                     setState={setFilters}/>
        );
      }
      return (
        <FormField fieldConfig={field} state={formState}
                   setState={setFormState}/>
      );
    });
  };

  return (
    <div className="filters-sidebar"
         style={{visibility: filtersVisibility && 'visible'}}>
      <div className="filters-sidebar__header">
        <h3>
          {intl.formatMessage({id: 'Algolia.SearchPage.Filters.Label'})}
        </h3>
        <Button buttonClasses="button--clear"
                onClick={() => setFiltersVisibility(false)}>
          <CloseIcon/>
        </Button>
      </div>

      <div className="flex flex-col md:items-center lg:items-start">
        <div className="flex justify-between mb-20 filters-sidebar__meta">
          <h5 className="filters-sidebar__heading">
            {intl.formatMessage({id: 'Algolia.SearchPage.Filters.Label'})}
          </h5>
          <Button buttonClasses="button--link" onClick={clearCallback}>
            {intl.formatMessage({id: 'Algolia.SearchPage.ClearButton.Label'})}
          </Button>
        </div>
        <div className="grid gap-30 lg:gap-48 filters-sidebar__filters">
          <div className="inline-flex md:hidden">
            <FormField fieldConfig={sortingFilters[0]} state={sortState}
                       setState={setSortState}/>
          </div>
          {renderFields()}
        </div>
      </div>
    </div>
  );
};

export default SidebarFilters;
